import * as React from "react";
import {PluginTemplates} from "@falcon/plugin-falcon-journey";
import {Link} from "react-router-dom";

interface IProps {
    message: any
}

export class RetrieveQuoteFailureMessagePage extends React.Component<IProps> {

    private pluginTemplates = new PluginTemplates();

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Quote retrieve failure");
    }

    public render() {
        return (
            <React.Fragment>
                {this.pluginTemplates.renderHeader()}

                <div className="inner-container retrieve-quote-failure-page error-page">
                    <h1 className="error-title">Something went wrong</h1>
                    <p className="error-text">{this.props.message}</p>
                    <Link className="btn btn-back" to="/retrieveQuote">
                        Go back
                    </Link>
                </div>

                {this.pluginTemplates.renderFooter()}
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/quote/RetrieveQuoteFailureMessagePage.tsx